module.exports = __webpack_public_path__ + "media/tsemppiaani5.5267a1c0.wav";